import { createFileRoute } from '@tanstack/react-router'
import { GoldCreditTransactionsTable } from '@/features/gold-credit-transactions'

export const Route = createFileRoute('/_authenticated/wallet/gold-cash-transactions')({
  component: () => <GoldCreditTransactionsTable walletType='gold_cash' />,
})
